import { useEffect, useRef } from "react";

const REVEAL_SELECTOR = ".reveal, .reveal-left, .reveal-right";

/**
 * Section ref — her .reveal elemanı viewport'a girdiğinde ayrı ayrı animasyon.
 * .stagger içindekiler CSS transition-delay ile sırayla dolar.
 */
export default function useReveal(options = {}) {
  const ref = useRef(null);

  useEffect(() => {
    const root = ref.current;
    if (!root) return;

    const threshold = options.threshold ?? 0.14;
    const rootMargin = options.rootMargin ?? "0px 0px -12% 0px";

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const el = entry.target;
          const staggerParent = el.closest(".stagger");

          if (staggerParent) {
            const siblings = [...staggerParent.querySelectorAll(REVEAL_SELECTOR)];
            const index = siblings.indexOf(el);
            const delay = index >= 0 ? index * (options.stagger ?? 110) : 0;
            window.setTimeout(() => {
              el.classList.add("revealed");
            }, delay);
          } else {
            el.classList.add("revealed");
          }

          observer.unobserve(el);
        });
      },
      { threshold, rootMargin },
    );

    const targets = root.querySelectorAll(REVEAL_SELECTOR);
    targets.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [options.stagger, options.threshold, options.rootMargin]);

  return ref;
}
